import React from 'react'

import { Box, ModalDialog, ModalDialogBody, ModalDialogCloseButton, ModalDialogContent, ModalDialogNav, type SwanStyleProps } from '@vp/swan'
import { SizeChart } from '@vp/lat-react-component-library'

import useSizeChartContext from '../../contexts/SizeChartContext/useSizeChartContext'
import { useProject } from '../../../root/contexts/ProjectContext'
import { useLocalizations } from '@vp/ubik-localizations-provider'

const SizeChartModal: React.FC<SwanStyleProps> = () => {
  const { sizeFitKey } = useProject()
  const { sizeChart, isSizeChartModalOpen, handleSizeChartClosed } = useSizeChartContext()
  const { t } = useLocalizations()

  return (
    <ModalDialog variant="panel-right" isOpen={isSizeChartModalOpen} onRequestDismiss={handleSizeChartClosed} onlyRenderWhenOpen>
      <ModalDialogContent aria-label={t('size-chart.dialog-aria-label-sizechart')}>
        <ModalDialogNav>
          <ModalDialogCloseButton data-testid="size-chart-close-button" accessibleText={t('close')} />
        </ModalDialogNav>
        <ModalDialogBody>
          <Box id="flyout-size-chart" data-testid="flyout-size-chart">
            <SizeChart sizeFitKey={sizeFitKey ?? undefined} {...sizeChart} />
          </Box>
        </ModalDialogBody>
      </ModalDialogContent>
    </ModalDialog>
  )
}

export default SizeChartModal
